import { McpStreamEvent } from "../Types/McpChat/McpChat";

const plumbingProgressText = new Set([
  "load_skill",
  "rename_conversation",
  "set_chat_summary",
]);

const fillerProgressText = new Set([
  "preparing...",
  "thinking...",
  "processing results...",
  "writing response...",
  "writing answers...",
  "writing feedback...",
  "working...",
  "mia is still responding...",
]);

export function isUserFacingProgressEvent(event: McpStreamEvent): boolean {
  if ((event.audience ?? "user") === "admin") {
    return false;
  }

  const text = (event.text ?? "").trim().toLowerCase();
  if (plumbingProgressText.has(text)) {
    return false;
  }

  const tool = (event.toolName ?? "").trim().toLowerCase();
  if (plumbingProgressText.has(tool) && (!text || plumbingProgressText.has(text))) {
    return false;
  }

  return true;
}

export function isFillerProgressStep(text: string | null | undefined): boolean {
  const normalised = (text ?? "").trim().toLowerCase().replace(/…/g, "...");
  return fillerProgressText.has(normalised);
}

/** Keep Thinking / Processing as the live spinner; don't leave them as completed steps. */
export function appendProgressStep(steps: string[], next: string): void {
  const trimmed = next.trim();
  if (!trimmed) {
    return;
  }

  if (steps.length === 0) {
    steps.push(trimmed);
    return;
  }

  const last = steps[steps.length - 1];
  if (last === trimmed) {
    return;
  }

  if (isFillerProgressStep(last)) {
    steps[steps.length - 1] = trimmed;
    return;
  }

  steps.push(trimmed);
}
